import { DispatchItemToExport, Constants } from "../../../../../core";
function isTripBetweenEntitites(item: DispatchItemToExport): boolean {
  return item.tripMode === Constants.tripMode.TRIP_BETWEEN_ENTITIES
}

function currentEntityDoesNotChange(item: DispatchItemToExport): boolean {
  const dispatchStatusList = Constants.DISPATCH_STATUS_LIST;
  return (
    (item.tripState === dispatchStatusList.TRIP_CREATED.text || item.tripState === dispatchStatusList.TRIP_CANCELLED.text) &&
    isTripBetweenEntitites(item)
  );
}

function currentEntityChange(item: DispatchItemToExport): boolean {
  const dispatchStatusList = Constants.DISPATCH_STATUS_LIST;
  return (
    (item.tripState === dispatchStatusList.TRIP_IN_TRANSIT.text || item.tripState === dispatchStatusList.TRIP_FINISHED.text) &&
    isTripBetweenEntitites(item)
  );
}

export const dispatchTrips = {
  exportFile: "viajes.xlsx",
  columns: [
    {
      title: "Fecha original de entrega",
      name: "originalDeliveryDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) =>
        element.originalDeliveryDate
          ? element.originalDeliveryDate
          : element.deliveryDate,
    },
    {
      title: "Fecha de entrega",
      name: "deliveryDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.deliveryDate,
    },
    {
      title: "Fecha de venta",
      name: "saleDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.saleDate,
    },
    {
      title: "Fecha de pago",
      name: "paymentDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.paymentDate,
    },
    {
      title: "N° de NV",
      name: "saleNoteId",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.saleNoteId,
    },
    {
      title: "N° de despacho",
      name: "dispatchId",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.dispatchId,
    },
    {
      title: "VTEX",
      name: "vtexCode",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.vtexCode,
    },
    {
      title: "SKU",
      name: "skuCode",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.skuCode,
    },
    {
      title: "Descripción",
      name: "skuName",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.skuName,
    },
    {
      title: "LPN",
      name: "lpn",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.lpn,
    },
    {
      title: "Cantidad total",
      name: "totalAmount",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) =>
        element.totalAmount != null ? element.totalAmount : 0,
    },
    {
      title: "Cantidad a despachar",
      name: "processedAmount",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.processedAmount,
    },
    {
      title: "Cantidad entregada",
      name: "dispatchedAmount",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: () => 0,
    },
    {
      title: "Cantidad cancelada",
      name: "canceledAmount",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) =>
        element.canceledAmount != null ? element.canceledAmount : 0,
    },
    {
      title: "Ubicación de Picking",
      name: "location",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.location,
    },
    {
      title: "Modalidad de despacho",
      name: "deliveryTypeName",
      type: "string",
      editable: false,
      checkAll: false,
      align: "left",
      class: "confirmationDispatches",
      value: (element: DispatchItemToExport) => element.deliveryTypeName,
    },
    {
      title: "Tipo de despacho",
      name: "dispatchTypeName",
      type: "string",
      editable: false,
      checkAll: false,
      align: "left",
      class: "confirmationDispatches",
      value: (element: DispatchItemToExport) => element.dispatchTypeName,
    },
    {
      title: "Estado",
      name: "state",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.state,
    },
    {
      title: "Entidad Actual",
      name: "currentEntityName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.currentEntityName,
    },
    {
      title: "Entidad de Venta",
      name: "saleLocationName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.saleLocationName,
    },
    {
      title: "Entidad destino de viaje",
      name: "nextEntityName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) =>
        currentEntityDoesNotChange(element)
          ? element.nextEntityName
          : isTripBetweenEntitites(element)? element.currentEntityName: '',
    },
    {
      title: "Ruta",
      name: "route",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.route,
    },
    {
      title: "Dirección de Entrega",
      name: "deliveryAddress",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) =>
        element.nextEntityName && currentEntityDoesNotChange(element)
          ? element.nextEntityAddress
          : currentEntityChange(element)
          ? element.entityAddress
          : element.deliveryAddress
          ? element.deliveryAddress.split("$%$").join(" ")
          : "",
    },
    {
      title: 'Distrito/Parroquias',
      name: 'dispatchDistrict',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) =>
        element.nextEntityName && currentEntityDoesNotChange(element)
          ? element.nextEntityDistrict
          : currentEntityChange(element)
          ? element.entityDistrict
          : element.dispatchDistrict,
    },
    {
      title: 'Departamento/Provincia',
      name: 'dispatchDepartment',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) =>
        element.nextEntityName && currentEntityDoesNotChange(element)
          ? element.nextEntityDepartment
          : currentEntityChange(element)
          ? element.entityDepartment
          : element.dispatchDepartment,
    },
    {
      title: 'Provincia/Cantones',
      name: 'dispatchProvince',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) =>
        element.nextEntityName && currentEntityDoesNotChange(element)
          ? element.nextEntityProvince
          : currentEntityChange(element)
          ? element.entityProvince
          : element.dispatchProvince,
    },
    {
      title: "Estado de Guía",
      name: "guideState",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.guideState,
    },
    {
      title: "N° de viaje",
      name: "id",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.dispatchTripId,
    },
    {
      title: "Estado de viaje",
      name: "tripState",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.tripState,
    },
    {
      title: "Zona de despacho",
      name: "dispatchZone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.dispatchZone,
    },

    {
      title: "Referencia",
      name: "reference",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.reference,
    },
    {
      title: "Documento de Cliente",
      name: "customerDocumentNumber",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.customerDocumentNumber,
    },
    
    {
      title: "Nombre de Cliente",
      name: "customer",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.customer,
    },
    {    
      title: "Email del Cliente",
      name: "mailCustomer",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.mailCustomer,
    },
    
    {
      title: "Teléfono de Cliente",
      name: "telephone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.telephone,
    },
    {
      title: "Documento persona que retira",
      name: "customerWithdrawDocument",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.withdrawPersonDoc,
    },
    {
      title: "Persona que retira",
      name: "customerWithdrawName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.withdrawPerson,
    },
    {
      title: "Inicio ventana horaria",
      name: "startDateDeliveryWindow",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.startDateDeliveryWindow,
    },
    {
      title: "Fin ventana horaria",
      name: "endDateDeliveryWindow",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.endDateDeliveryWindow,
    },
    {
      title: "Tipo de viaje",
      name: "tripType",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.tripType,
    },
    {
      title: "Sucursal de despacho",
      name: "entityName",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.entityName,
    },
    {
      title: "Fecha de envío programada",
      name: "plannedDeliveryTripDate",
      sort: false,
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.plannedDeliveryTripDate,
    },
    {
      title: "Fecha de envío real",
      name: "shippingTripDate",
      sort: false,
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.shippingTripDate,
    },
    {
      title: "N° placa",
      name: "plateNumber",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.plateNumber,
    },
    {
      title: "Sistema de creación",
      name: "originTrip",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.originTrip,
    },
    {
      title: "% Asignados",
      name: "completePercentage",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) =>
        element.completePercentage + "%",
    },
    {
      title: "% Cargados",
      name: "completePercentageLoaded",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) =>
        element.completePercentageLoaded + "%",
    },
    {
      title: "Respuesta de Beetrack",
      name: "beetrackResponse",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.beetrackResponse,
    },
  ],
};
